import React, { Component, PropTypes } from 'react';

class ClickEditCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseOver: false,
      value: props.stringAllowed ? props.children : transformNumber(props.children, undefined, props.decimalNumber),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.children !== nextProps.children) this.setState({ value: nextProps.children });
  }

  _handleMouseOver = () => {
    this.setState({ mouseOver: true });
  };

  _handleMouseLeave = () => {
    this.setState({ mouseOver: false })
  };

  _handleOnChange = e => {
    if (!this.props.stringAllowed && isNaN(e.target.value)) window.alert('Please enter numbers only.');
    this.props.onChange(e.target.value);
  };

  _handleOnBlur = e => {
    if (this.state.value && !this.props.stringAllowed) this.setState({ value: Number(this.state.value).toFixed(this.props.decimalNumber) }, () => {
      if (this.props.onBlur) this.props.onBlur(e);
    });
  };

  render() {
    const { style, editable, children, inputAlignRight, fullWidthInput, multiLine, showBorder, stringAllowed, decimalNumber, defaultValue, className } = this.props;
    if (editable) return (
      <div style={style}>
        {
          multiLine ? <textarea
            style={{ border: '1px solid #00BCD4', textAlign: inputAlignRight ? 'right' : 'left', width: fullWidthInput ? '100%' : '' }}
            className={`clickEditCell ${className}`}
            rows={multiLine}
            value={this.state.value || ''}
            onBlur={this._handleOnBlur}
            onChange={this._handleOnChange}
            onMouseOver={this._handleMouseOver}
            onMouseLeave={this._handleMouseLeave}
          /> : <input
            style={{ border: '1px solid #00BCD4', textAlign: inputAlignRight ? 'right' : 'left', width: fullWidthInput ? '100%' : '' }}
            className={`clickEditCell ${className}`}
            value={this.state.value || ''}
            onBlur={this._handleOnBlur}
            onChange={this._handleOnChange}
            onMouseOver={this._handleMouseOver}
            onMouseLeave={this._handleMouseLeave}
          />
        }
      </div>
    );
    const nonEditableContent = (() => {
      if (stringAllowed) return children;
      return transformNumber(children, defaultValue, decimalNumber);
    })();
    return (
      <div style={style}>
        <span className={className}>{nonEditableContent}</span>
      </div>);
  }
};

const transformNumber = (value, defaultValue, decimalNumber) => {
  if (isNaN(value) || !value) {
    return defaultValue;
  }
  return Number(value).toFixed(decimalNumber);
};

ClickEditCell.propTypes = {
  style: PropTypes.object,
  editable: PropTypes.bool,
  inputAlignRight: PropTypes.bool,
  children: PropTypes.node,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  updateTableCell: PropTypes.func,
  cellRow: PropTypes.number,
  cellColumn: PropTypes.string,
  stringAllowed: PropTypes.bool,
  decimalNumber: PropTypes.number,
  onBlur: PropTypes.func,
  className: PropTypes.string,
};

export default ClickEditCell;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/click-edit-cell.jsx